module.exports = __webpack_public_path__ + "static/media/CitrusStage4.60d81d18.PNG";